import React from "react";

interface PlanKeyProps {
  size?: number;
  color?: string;
}

const PlanKey: React.FC<PlanKeyProps> = ({ size = 16, color = "currentColor" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.30082 9.22645C4.6209 9.81079 3.841 10.0671 2.96111 9.98507C2.08122 9.90306 1.35131 9.50324 0.771377 8.79588C0.191448 8.08852 -0.0585215 7.27865 0.0114699 6.3765C0.0814613 5.46411 0.461415 4.71574 1.14133 4.1314C1.69126 3.65983 2.30119 3.40354 2.98111 3.36253C3.65102 3.33177 4.25095 3.48555 4.79088 3.80335L9.20034 0L10.5602 1.67101L12 3.44454L10.2002 4.99254L8.81039 3.29077L6.22071 5.53587C6.45068 6.16122 6.50067 6.81732 6.35069 7.49393C6.20071 8.17054 5.85075 8.74463 5.30082 9.22645ZM3.91099 7.52468C4.13096 7.3299 4.26095 7.08386 4.28095 6.77632C4.30094 6.46877 4.22095 6.20223 4.03098 5.96644C3.841 5.73065 3.60103 5.59738 3.30107 5.57688C3.0011 5.54612 2.74114 5.62814 2.52116 5.82292C2.30119 6.0177 2.17121 6.26374 2.15121 6.57128C2.13121 6.87883 2.2112 7.14537 2.40118 7.38116C2.59115 7.61695 2.83112 7.75022 3.13109 7.77072C3.43105 7.80148 3.69102 7.71946 3.91099 7.52468Z"
        fill={color}
      />
    </svg>
  );
};

export default PlanKey;